module.exports = __webpack_public_path__ + "img/log.4339e07a.png";